import { Box, Button, Heading, HStack, Link, Text, VStack } from '@medely/ui-kit';
import React, { ReactElement } from 'react';
import { FixedFooterLayout } from '../../FixedFooterLayout/index';
import { useProNavigate } from '../../../contexts';
import { useProRouteParams } from '../../../hooks/useProRouteParams';

const LEARN_MORE_URL = 'https://help.medely.com/en/articles/10270319-what-are-professional-pools';

export const PoolInterestSubmitted = ({ header }: { header?: ReactElement }): ReactElement => {
  // poolId is read so the route contract is honored now and FE-6/FE-9 can use it for
  // pool-scoped copy + opt-out without changing the navigation call sites.
  useProRouteParams<'PoolInterestSubmitted'>('PoolInterestSubmitted');
  const { navigate } = useProNavigate();

  return (
    <FixedFooterLayout
      footerContent={
        <Button fullWidth onClick={() => navigate('Today')} testId="pool-interest-submitted-done">
          Done
        </Button>
      }
    >
      {header && <>{header}</>}
      <VStack alignItems="center" width="100%">
        <VStack alignItems="center" mx={4} maxWidth="343px">
          <VStack alignItems="center" mb={4}>
            <Heading size="s">Your interest has been submitted</Heading>
            <Text size="l">
              This facility reviews interested professionals before onboarding begins. We&apos;ll
              let you know when you can continue.
            </Text>
          </VStack>
          <HStack>
            <Box pr={0.5}>
              <Text size="m">Have questions?</Text>
            </Box>
            <Link variant="text" size="m" url={LEARN_MORE_URL}>
              Learn more
            </Link>
            <Text size="m">.</Text>
          </HStack>
        </VStack>
      </VStack>
    </FixedFooterLayout>
  );
};
